import React, { useState } from 'react';
import axios from 'axios';
import { Send, Check, AlertCircle } from 'lucide-react';
import AnimatedSection from '../ui/AnimatedSection';
import { useLanguage } from '../../context/LanguageContext';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterSection = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_URL}/newsletter`, { email });
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 4000);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(
        Array.isArray(detail)
          ? detail.map((d) => d.msg).join(', ')
          : detail || t('newsletter.errorGeneric')
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-16 bg-[#5B7A8A]/10 border-t border-[rgba(91,122,138,0.2)]">
      <div className="container-swg">
        <AnimatedSection>
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="heading-4 text-white mb-4">{t('newsletter.title')}</h3>
            <p className="text-[#9AACB8] mb-8">{t('newsletter.sub')}</p>

            <form
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row gap-4 justify-center"
              data-testid="newsletter-form"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('newsletter.placeholder')}
                required
                disabled={loading || subscribed}
                className="flex-1 max-w-md bg-[#1a1c1b] border border-[rgba(91,122,138,0.3)] rounded-full px-6 py-3 text-white placeholder-[#9AACB8] focus:outline-none focus:border-[#5B7A8A] transition-colors disabled:opacity-60"
                data-testid="newsletter-input"
              />
              <button
                type="submit"
                disabled={loading || subscribed}
                className="btn-primary disabled:opacity-60 disabled:cursor-not-allowed"
                data-testid="newsletter-submit"
              >
                {subscribed ? (
                  <>
                    <Check className="w-4 h-4 mr-2" />
                    {t('newsletter.subscribed')}
                  </>
                ) : loading ? (
                  <>{t('newsletter.subscribing')}</>
                ) : (
                  <>
                    {t('newsletter.subscribe')}
                    <Send className="w-4 h-4 ml-2" />
                  </>
                )}
              </button>
            </form>

            {error && (
              <div
                className="mt-4 inline-flex items-center gap-2 text-red-300 text-sm"
                data-testid="newsletter-error"
              >
                <AlertCircle className="w-4 h-4" />
                <span>{error}</span>
              </div>
            )}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default NewsletterSection;
